<template>
  <div class="network-error">
    <div class="error-content">
      <el-icon :size="80" color="#f56c6c"><CircleCloseFilled  /></el-icon>
      <h2>网络连接失败</h2>
      <p class="error-message">{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { CircleCloseFilled  } from '@element-plus/icons-vue'
import { computed } from 'vue'

const route = useRoute()

// 从路由参数中获取错误类型
const errorType = computed(() => route.query.type || 'network')

const errorMessage = computed(() => {
  if (errorType.value === 'timeout') {
    return '请求超时，请检查网络连接后重试'
  }
  return '无法连接到服务器，请检查网络设置'
})
</script>

<style scoped>
.network-error {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  text-align: center;
}
.error-content {
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}
h2 {
  margin: 20px 0 10px;
  color: #333;
}
.error-message {
  color: #666;
  margin-bottom: 24px;
}
.el-button {
  margin: 0 8px;
}
</style>